import React from 'react';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import { STATUS_BY_STATE } from "../../helpers/constants";

const AppStatus = (v) => {
    if (v === 'REQUEST_FAILED') {
        return <div className='warning'>
            <Tooltip
                color='#ffffff'
                key='#ffffff'
                placement="topLeft"
                title='Դիմումը չի կարող մշակվել։ Ստեղծեք նոր դիմում։'
            >
                <WarningOutlined style={{ color: '#FF5252' }} />
            </Tooltip>
        </div>;
    }

    return (
        <div className={`oval ${STATUS_BY_STATE[v]}`}/>
    )
};

AppStatus.propTypes = {};

export default AppStatus;
